export const coupleNames = 'Lucia & John'

